import React from 'react'
import { FeatureImage, FeatureImageType } from 'js/components/FeatureImage'

type Props = {
  image: FeatureImageType
  title: string
  description: string
  className?: string
}

const Card = ({ image, title, description }: Props) => {
  return (
    <div className="flex flex-col items-center gap-x-[32px] rounded-16 bg-BgContent p-24 md:flex-row lg:flex-col">
      <div className="mb-24 aspect-square h-[150px]">
        <FeatureImage
          image={image}
          className="order-1 h-full object-cover lg:mx-auto"
        />
      </div>
      <div className="relative order-1 md:-order-1 lg:order-1">
        <h3 className="quincy pb-12 text-24 leading-27">{title}</h3>
        <p className="text-17 font-semiregular leading-21">{description}</p>
      </div>
    </div>
  )
}

export default Card
